import type { Crop } from 'react-image-crop'

interface BlobProps {
  completedCrop: Crop | null
  imgRef: React.RefObject<HTMLImageElement>
  previewCanvasRef: React.MutableRefObject<null>
  setCroppedResult: (blob: Blob | null) => void
}

/**
 * This method displays the selected image in the view box after cropping the image
 */
export const setBlob = (props: BlobProps) => {
  const { completedCrop, previewCanvasRef, imgRef, setCroppedResult } = props
  if (!completedCrop || !previewCanvasRef.current || !imgRef.current) {
    return
  }

  const image: HTMLImageElement = imgRef.current
  const canvas: HTMLCanvasElement = previewCanvasRef.current
  const blobCrop: Crop = completedCrop

  const scaleX = image.naturalWidth / image.width
  const scaleY = image.naturalHeight / image.height

  const ctx = canvas.getContext('2d') as CanvasRenderingContext2D
  const pixelRatio = window.devicePixelRatio

  canvas.width = blobCrop.width * pixelRatio * scaleX
  canvas.height = blobCrop.height * pixelRatio * scaleY

  ctx.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0)
  ctx.imageSmoothingQuality = 'high'

  ctx.drawImage(
    image,
    blobCrop.x * scaleX,
    blobCrop.y * scaleY,
    blobCrop.width * scaleX,
    blobCrop.height * scaleY,
    0,
    0,
    blobCrop.width * scaleX,
    blobCrop.height * scaleY
  )

  canvas.toBlob((blob) => {
    if (blob) {
      setCroppedResult(blob)
    }
  }, 'image/jpeg')
}
